<template>
  <div class="text-center">
    <v-dialog
      v-model="show"
      max-width="600px"
    >
      <v-card class="pt-8">
        <v-card-text>
          <p class="home-page-popup-message" v-html="whitelabel.homePagePopupMessage" />
        </v-card-text>
        <v-card-actions class="pb-3 buttons-block">
          <v-row>
            <v-col cols="12" sm="4">
              <v-btn color="primary" block depressed rounded @click="$router.push('/signup')">Sign up</v-btn>
            </v-col>
            <v-col cols="12" sm="4">
              <v-btn color="primary" block depressed rounded @click="$router.push('/forgot-password')">Reset password</v-btn>
            </v-col>
            <v-col cols="12" sm="4">
              <v-btn color="primary" depressed block rounded outlined @click="show = false">Close</v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script lang="js">
export default {
  name: 'HomePagePopup',
  props: {
    value: Boolean,
  },
  computed: {
    show: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.home-page-popup-message {
  line-height: 1.8;
}
</style>
